export const initFormData: {
  id: string;
  siteId: number;
  billCode: number;
  abnormal1: string;
  contractProjectId: any;
  abnormalValueList: string[];
  remark: string;
} = {
  id: "",
  siteId: 0,
  billCode: 0,
  abnormal1: "",
  contractProjectId: "",
  abnormalValueList: [],
  remark: "",
};

export const initFormData1: {
  id: string;
  siteId: number;
  billCode: number;
  fee: number;
  contractProjectId: any;
  dictCode: string;
  dictName: string;
  remark: string;
} = {
  id: "",
  siteId: 0,
  billCode: 0,
  fee: 0,
  dictCode: "",
  dictName: "",
  contractProjectId: "",
  remark: "",
};
